import { Chip, Typography } from "@mui/material";
import React, { FC } from "react";
import { TransformedVariantEntity } from "../../../../types/transformed_product_entity";
import { SizeChartDialog } from "./SizeChartDialog";

interface Props {
  showSizeChart: boolean;
  variants: TransformedVariantEntity[];
  selectedVariant: TransformedVariantEntity;
  setSelectedVariant: (data: TransformedVariantEntity) => void;
  category: string;
}

export const SelectSizes: FC<Props> = ({
  variants,
  selectedVariant,
  setSelectedVariant,
  showSizeChart,
  category,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-4">
        <Typography variant="subtitle1">Sizes</Typography>
        {showSizeChart && (
          <SizeChartDialog
            url={
              category === "Bangle"
                ? "https://cdn.picpil.com/assets/2022/04/117/photo_2022-04-27_11.41.49.jpeg"
                : "https://cdn.picpil.com/assets/2022/11/329/finger_ring_size_chart.jpg"
            }
          />
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {variants.map((variant: TransformedVariantEntity) => {
          return (
            <Chip
              onClick={() => setSelectedVariant(variant)}
              key={variant.id}
              label={variant.size ? variant.size : "One Size"}
              color={
                selectedVariant.id === variant.id ? "secondary" : "default"
              }
              sx={{
                opacity: variant.availability === "OUT-OF-STOCK" ? 0.5 : 1,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
